import { ReactElement } from "react";
import {
  FormControl,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from "@mui/material";
import StyledTableRow from "../../../components/styledTableRow";
import { IDashboardGroup, DashboardOrderType, IDataSchema } from "../types";
import { Add, Delete } from "@mui/icons-material";
import { getPalette } from "../../../configuration/configuration";
import Select  from "@mui/material/Select";
import TableContainer from "../../../components/tableContainer";

interface IProps {
  schema: IDataSchema;
  groups: IDashboardGroup[];
  updateGroups: (series: IDashboardGroup[]) => void;
}

const GroupTable = ({ groups, updateGroups, schema }: IProps): ReactElement => {

  const addSeries = () => {
    updateGroups([ ...groups, { field: "", order: DashboardOrderType.Asc } ]);
  };

  const removeSeries = (index: number) => {
    const newGroups = [ ...groups ];
    newGroups.splice(index, 1);
    updateGroups(newGroups);
  };

  const updateItemsSeries = (index: number, field: keyof IDashboardGroup, value: any) => {
    const newGroups = [ ...groups ];
    const item = newGroups[index] as any;
    item[field] = value;
    updateGroups(newGroups);
  };

  return (
    <TableContainer sx={{ maxHeight: 315 }}>
      <Table stickyHeader={true} size={"small"}>
        <TableHead>
          <TableRow>
            <TableCell className="table-header" style={{ minWidth: 328, padding: "8px" }}>
              <IconButton sx={{ padding: "2px"  }} onClick={addSeries} disabled={groups.length > 3} size={"small"}>
                <Tooltip title={"Add group"}>
                  <Add style={{ color: getPalette().statusColor.info.background }}/>
                </Tooltip>
              </IconButton>
            Field
            </TableCell>
            <TableCell className="table-header" style={{ minWidth: 270 }}>Order</TableCell>
            <TableCell className="table-header" style={{ minWidth: 50 }}/>
          </TableRow>
        </TableHead>
        <TableBody>
          {groups.map((row, index) => {
            return (
              <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`group-row-${index}`}>
                <TableCell>
                  <Select
                    variant="standard"
                    className="w-100"
                    value={row.field}
                    displayEmpty={true}
                    onChange={(event) => updateItemsSeries(index, "field", event.target.value as string)}>
                    {Object.keys(schema.dimensions).map(field => <MenuItem key={`field-${index}-${field}`} value={field}>{field}</MenuItem>)}
                  </Select>
                </TableCell>
                <TableCell>
                  <FormControl className="w-100">
                    <Select
                      variant="standard"
                      value={row.order}
                      displayEmpty={true}
                      onChange={(event) => updateItemsSeries(index, "order", event.target.value as DashboardOrderType)}>
                      <MenuItem value={DashboardOrderType.None}>None</MenuItem>
                      <MenuItem value={DashboardOrderType.Asc}>Asc</MenuItem>
                      <MenuItem value={DashboardOrderType.Desc}>Desc</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <IconButton sx={{ padding: "2px" }} onClick={() => removeSeries(index)} size={"small"}>
                    <Tooltip title={"Remove series"}>
                      <Delete style={{ color: getPalette().statusColor.error.background }}/>
                    </Tooltip>
                  </IconButton>
                </TableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GroupTable;
